import React, { useEffect } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { HeaderV5 } from '../components/report/v5/HeaderV5';
import { FeaturedOnline } from '../components/report/v5/FeaturedOnline';
import { PerformanceV5 } from '../components/report/v5/PerformanceV5';
import { TargetedArea } from '../components/report/v5/TargetedArea';
import { MarketingAssets } from '../components/report/v5/MarketingAssets';
import { ToolkitV5 } from '../components/report/v5/ToolkitV5';
import { FooterV5 } from '../components/report/v5/FooterV5';
// Philadelphia marketing report — Berkshire Hathaway HomeServices Fox & Roach,
// Realtors. A formal, single-column "document" layout, cabernet-branded.
export function MarketingReportPhilly({
  onBack
}: {
  onBack?: () => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="report-print-scale min-h-screen w-full bg-secondary/40 py-8 text-foreground sm:py-12" data-id="element-882" data-mp="3r6qsiejn6vvh">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-0" data-id="element-883" data-mp="3m8fio3tckld9">
        {onBack && <button onClick={onBack} className="mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-bhhs-cab print:hidden" data-id="element-884" data-mp="2hat643nm2yif">
            <ArrowLeftIcon className="size-4" data-id="element-885" data-mp="2q8mrwknr29rc" /> Back to My Orders
          </button>}
        <div className="w-full bg-background px-6 py-8 shadow-sm ring-1 ring-border sm:px-10 sm:py-10 print:shadow-none print:ring-0" data-id="element-886" data-mp="2vau85mfm4bzh">
          <HeaderV5 data-id="element-887" data-mp="306j6xnjt5ouq" />
          <div className="mt-8 space-y-10 print:space-y-6" data-id="element-888" data-mp="356x76jf63ui7">
            <FeaturedOnline data-id="element-889" data-mp="355cbgqh4a5ir" />
            <PerformanceV5 data-id="element-890" data-mp="39yfahe4ny76c" />
            <TargetedArea data-id="element-891" data-mp="39z89fsxdrsdx" />
            <MarketingAssets data-id="element-892" data-mp="39yyquqeo0ni9" />
            <ToolkitV5 data-id="element-893" data-mp="3dzr03jnjesej" />
          </div>
          <FooterV5 data-id="element-894" data-mp="3dypeil8wanik" />
        </div>
      </div>
    </main>;
}